import React from "react";
import { Radio, Tooltip, Badge } from "antd";
import { GlobalOutlined, ClockCircleOutlined, HomeOutlined } from "@ant-design/icons";
import { useTimeZone, TIMEZONE_OPTIONS } from "../contexts/TimeZoneContext";

/**
 * 时区切换组件
 * 提供UTC、北京时间和机场当地时间三种模式切换
 * @param {Object} props - 组件属性
 * @param {string} props.airportCode - 当前机场代码（可选，用于LOCAL模式）
 * @param {Object} props.airportsMap - 机场数据映射（可选，用于LOCAL模式）
 * @param {Object} props.style - 额外样式对象
 */
const TimeZoneSelector = ({ airportCode, airportsMap = {}, style = {} }) => {
    const { timeZone, setTimeZone, isLocal } = useTimeZone();

    // 如果使用LOCAL模式但没有机场代码，添加警告
    const showLocalWarning = isLocal && (!airportCode || !airportsMap[airportCode]);

    // 获取当前机场的时区名称（如果有）
    let localTimezoneDisplay = "LT";
    if (airportCode && airportsMap[airportCode]?.timezone) {
        const offset = airportsMap[airportCode]?.utc_offset || "";
        if (offset) {
            localTimezoneDisplay = `LT (UTC${offset})`;
        }
    }

    return (
        <div className="timezone-selector" style={style}>
            <Radio.Group value={timeZone} onChange={(e) => setTimeZone(e.target.value)} optionType="button" buttonStyle="solid" size="small">
                <Tooltip title="世界协调时间 (UTC)">
                    <Radio.Button value={TIMEZONE_OPTIONS.UTC}>
                        <GlobalOutlined /> UTC
                    </Radio.Button>
                </Tooltip>
                <Tooltip title="北京时间 (UTC+8)">
                    <Radio.Button value={TIMEZONE_OPTIONS.BEIJING}>
                        <ClockCircleOutlined /> UTC+8
                    </Radio.Button>
                </Tooltip>
                <Tooltip title={showLocalWarning ? "未找到机场时区信息，将使用UTC" : "使用机场当地时间"}>
                    <Badge dot={showLocalWarning} color="red">
                        <Radio.Button value={TIMEZONE_OPTIONS.LOCAL}>
                            <HomeOutlined /> {localTimezoneDisplay}
                        </Radio.Button>
                    </Badge>
                </Tooltip>
            </Radio.Group>
        </div>
    );
};

export default TimeZoneSelector;
